/* eslint-disable @typescript-eslint/no-explicit-any */

import type yup from './yup'
import type { SubmissionContext } from 'vee-validate'

export default function getSubmitFn<
  Schema extends yup.ObjectSchema<Record<string, any>>
>(
  _: Schema,
  callback: (values: yup.InferType<Schema>, actions: SubmissionContext) => void
) {
  return (values: Record<string, any>, actions: SubmissionContext) => {
    return callback(values, actions)
  }
}
